// LeadDetail.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ENQUIRY_LEAD_VIEW, GET_Lead_leadId } from '../../../services/apiRoutes';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import DetailPageCustum from '../../../components/common/DetailsPage/DetailPageCustum';

const EnquiryLeadDetail = () => {
    const { leadId } = useParams();
    const [leadDetails, setLeadDetails] = useState(null);

    useEffect(() => {
        const authToken = sessionStorage.getItem('accessToken');

        axios.get(ENQUIRY_LEAD_VIEW(leadId), {
            headers: {
                Authorization: `Bearer ${authToken}`,
            }
        })
            .then(response => {
                setLeadDetails(response.data.lead);
            })
            .catch(error => {
                console.error('Error fetching lead details:', error);
            });
    }, [leadId]);

    if (!leadDetails) {
        return <p>Loading...</p>;
    }


    const tableData = [
        { label: 'Client Company', value: leadDetails.clientCompany?.companyName || '' },
        { label: 'Contact Person', value: `${leadDetails?.titlesModel?.titleName || ''} ${leadDetails?.firstName || ''} ${leadDetails?.lastName || ''}` },
        { label: 'Email', value: leadDetails.email || '' },
        { label: 'Mobile', value: `+${leadDetails?.phonecode?.phonecode || ''}${leadDetails?.mobile || ''}` },
        { label: 'Address', value: `${leadDetails?.street || ''}, ${leadDetails.city?.name || ''}, ${leadDetails.state?.name || ''}, ${leadDetails.country?.name || ''}, ${leadDetails.zipCode || ''}.` },
    ];

    return <DetailPageCustum Icon={LeaderboardOutlinedIcon} title="Lead Details" data={tableData} />;
};

export default EnquiryLeadDetail;
